import { render, staticRenderFns } from "./IniciaTramite.vue?vue&type=template&id=417c2e4e&"
import script from "./IniciaTramite.vue?vue&type=script&lang=js&"
export * from "./IniciaTramite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports